import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { UtilitysService } from 'src/app/services/utilitys/utilitys.service';
import { ModalService } from '../modal.service';
import { ApiService } from 'src/app/services/api/api.service';

@Component({
  selector: 'app-modal-reward',
  templateUrl: './modal-reward.component.html',
  styleUrls: ['./modal-reward.component.scss']
})
export class ModalRewardComponent implements OnInit {

  @ViewChild('rewardModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-lg modal-pretty-popup', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };
  reward: any = {};
  myProfile: any = {};
  isShow = true;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
    private utility: UtilitysService,
    private api: ApiService,
  ) { }

  ngOnInit() {
    this.modalServ.onReward.subscribe(req => {
      this.getMyProfile(); 
      // console.log('req',req);
      this.reward = req.item;
      this.isShow = typeof req.isShow !== 'undefined' ? req.isShow : this.isShow;
      // console.log(this.reward);
      // console.log('isshow', this.isShow);
      // if(!this.isShow) {this.show();}
      if(this.isShow) {this.show();}
    });

    this.modalServ.onRewardHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }

  async getMyProfile() {
    this.myProfile = await this.utility.getMyProfile();
    // console.log(this.myProfile);
  }

  onRedemption() {
    if((this.myProfile.CurrentPoint >= this.reward.PointRedeem) || (this.reward.TotalQty > 0)){
      this.modalServ.onRewardHide.emit();
      setTimeout(() => {
        this.modalServ.onRedemption.emit({reward: this.reward});
      }, 500);
    }
     
    //  if((this.myProfile.CurrentPoint >= this.reward.PointRedeem) || (this.reward.TotalQty > 0)){
    //     this.modalServ.onRewardHide.emit();
    //     this.modalServ.onRedeemInformation.emit({reward: this.reward,myProfile:this.myProfile});
    //   }
  }

  favoriteItem(item: any){
    console.log(item);
    if(item.IsFavorite){
        var favoriteModel: any = {};
        favoriteModel.contentId = item.RewardID;
        favoriteModel.contentType = "reward";
        this.api.deleteFavorite(favoriteModel).subscribe(res => {
          if(res.Code == 200) {
            item.IsFavorite =false;
          } else {
            console.error(res);
          }
        }, err => {
          console.error(err);
        });
    }
    else{ 
        var favoriteModel: any = {};
        favoriteModel.contentId = item.RewardID;
        favoriteModel.contentType = "reward";
        this.api.crateFavorite(favoriteModel).subscribe(res => {
          if(res.Code == 200) {
            item.IsFavorite = true;
          } else {
            console.error(res);
          }
        }, err => {
          console.error(err);
        });
    }
  }
}
